import { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import Loader from './../components/loader';
import TokenExpiryModal from "../components/tokenModal";
import { useDataContext } from "./data";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState(null);
  const navigate = useNavigate();
  const {setItems} = useDataContext()

  useEffect(() => {

    const checkAndRefreshToken = async () => {

      const token = localStorage.getItem("token");
    
      if (!token) {
        setIsAuthenticated(false);
        setLoading(false);
        // navigate("/login");
        return;
      }

      try {
        // 🔄 Vérification et renouvellement du token
        const response = await api.auth.auto_login();

        if (response.token) {
          
          console.log("Token renouvelé avec succès :", response.token);
          localStorage.setItem("token", response.token);
          setItems(response.user)

          const newExpiration = new Date().getTime() + 5 * 60 * 1000; // Ajout de 5 minutes
          localStorage.setItem("token_expiration", new Date(newExpiration).toISOString());

          setIsAuthenticated(true);
          setTimeLeft(300); // 5 minutes (300s)


        } else {
          throw new Error("Le renouvellement du token a échoué.");
        }

      } catch (error) {
        console.error("Erreur lors du renouvellement du token :", error);
        // localStorage.removeItem("token");
        setIsAuthenticated(false);
        // navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    checkAndRefreshToken();
  }, [navigate]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
      {loading ? <Loader /> : children}
      {isAuthenticated && <TokenExpiryModal />}
    </AuthContext.Provider>
  );
};
